module.exports = __webpack_public_path__ + "static/SLT_P_MUJ_V7-9bd356dcb8a1d7b74d871e8ea63d06e9.svg";